import {
  APP_DETAILS,
  BANK_DETAILS,
  BANNERS,
  POST_LOGIN_MODAL,
  SHOW_RIGHT_SIDEBAR,
} from "./types";
import { axiosService } from "../../utils/axiosService";
import { API_URLS } from "../../config/apiUrls";
import { APP_CONST } from "../../config/const";
import { AxiosError } from "axios";
import { Toaster } from "../../utils/toaster";

export const getAppDetails = (onRequestComplete) => (dispatch) => {
  const result = axiosService.get(API_URLS.APP.APP_DETAILS);
  result.then((res) => {
    if (res?.data?.error === false) {
      onRequestComplete();
      dispatch({
        type: APP_DETAILS,
        payload: res?.data?.data,
      });
    }
  });
};
export const getActiveBankDetails = () => (dispatch) => {
  try {
    const result = axiosService.get(API_URLS.APP.BANK_DETAILS);
    result
      .then((res) => {
        dispatch({
          type: BANK_DETAILS,
          payload: res.data.data.bankDetails,
        });
      })
      .catch((err) => {
        console.debug(err);
      });
  } catch (err) {
    console.debug(err);
  }
};

export const getBanners = () => (dispatch) => {
  try {
    const result = axiosService.get(API_URLS.APP.GET_BANNERS);
    result.then((res) => {
      dispatch({
        type: BANNERS,
        payload: res.data?.data?.banners,
      });
    });
    return result;
  } catch (err) {
    console.debug(err);
  }
};

// Get notifications

export const getNotifications = async () => {
  try {
    return await axiosService.get(API_URLS.APP.GET_NOTIFICATIONS);
  } catch (err) {
    if (err instanceof AxiosError) {
      // Toaster(
      //   APP_CONST.TOAST_TYPE.ERROR,
      //   err?.response?.data?.message || "Failed to get notifications"
      // );
    }
    console.log(err);
  }
};

export const handleRightSideBar = (booleanValue) => (dispatch) => {
  dispatch({
    type: SHOW_RIGHT_SIDEBAR,
    payload: booleanValue,
  });
};

export const handlePostLoginModal = (booleanValue) => (dispatch) => {
  dispatch({
    type: POST_LOGIN_MODAL,
    payload: booleanValue,
  });
};
